import { DateUtil } from '@aon/aon-tws-common-ui';

export const SummaryItemDateHelper = {
	getDate(str?: string) {
		if (!str) {
			return null;
		}
		const date = new Date(str);
		if (date.toString() === 'Invalid Date') {
			return str;
		}
		return DateUtil.formatDateToLocal(date);
	},
	getDateRange(strs?: string[]) {
		if (!strs) {
			return null;
		}
		const dates = strs.map((s: string) => this.getDate(s));

		return dates.join(' - ');
	},
};
